import { DateTime } from "luxon";

export const getDaysLeftUntilEndDate = (startDate: string, endDate: string) => {

    const isLate = DateTime.fromISO(endDate).toSeconds() < DateTime.utc().toSeconds();
    const daysLate = DateTime.utc().diff(DateTime.fromISO(endDate), ["days"]).days;
    const daysLeft = DateTime.fromISO(endDate).diff(DateTime.fromISO(startDate), ["days"]).days;

    return isLate ? -Math.floor(daysLate) : Math.floor(daysLeft);
}